import { t } from 'i18next';
import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import * as Yup from 'yup';
import { groupInputs } from '../../inputs/group.inputs';

const form: FormInput[] = [groupInputs.name, groupInputs.notificationEmail, groupInputs.members];

const created = createForm(form);

export const groupForm = {
  Element: created.Element,
  meta: {
    initValues: {
      ...created.meta.initValues,
      name: '',
      vehicleIds: [] as string[],
      userIds: [] as string[],
    },
    validateSchema: created.meta.validateSchema.concat(
      Yup.object().shape({
        name: Yup.string()
          .trim()
          .required(() => t('Group:nameRequired')),
        vehicleIds: Yup.array().of(Yup.string()),
        userIds: Yup.array().of(Yup.string()),
      })
    ),
  },
};

export type GroupFormBody = {
  name: string;
  notificationEmail?: string | null;
  vehicleIds: string[];
  userIds: string[];
};
